import React, { memo } from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { fromJS } from 'immutable';

import FormGroup from '../../helpers/FormGroup';
import Select from '../../helpers/Select';

const OPTIONS = fromJS(
  (function() {
    const monthOptions = [{ value: '', name: '' }];

    for (let month = 0; month < 12; month++) {
      const date = dayjs()
        .month(month)
        .endOf('month');
      const name = date.format('D MMM');

      monthOptions.push({ value: date.month() + 1, name });
    }

    return monthOptions;
  })(),
);

const FinancialYearEndComponent = props => {
  const { className, ...rest } = props;
  const cls = classNames('input-sm', className);

  return (
    <FormGroup>
      <Select {...rest} className={cls} label="FYE" options={OPTIONS} showLabel />
    </FormGroup>
  );
};

/** Financial year end component. */
export const FinancialYearEnd = memo(FinancialYearEndComponent);
